import React from 'react';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ page, totalPages, onPageChange }) => {
  return (
    <div className="flex items-center justify-center gap-2 mt-4">
      <button
        className="px-3 py-1 rounded-full border border-primary text-primary bg-white font-semibold shadow-sm hover:bg-[#e6f0fa] transition disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page === 1}
        type="button"
      >
        前へ
      </button>
      {[...Array(totalPages)].map((_, i) => (
        <button
          key={i}
          className={`px-3 py-1 rounded-full font-semibold shadow-sm border transition ${page === i + 1 ? 'bg-primary text-white border-primary' : 'bg-white text-primary border-primary hover:bg-[#e6f0fa]'}`}
          onClick={() => onPageChange(i + 1)}
          type="button"
        >
          {i + 1}
        </button>
      ))}
      <button
        className="px-3 py-1 rounded-full border border-primary text-primary bg-white font-semibold shadow-sm hover:bg-[#e6f0fa] transition disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        type="button"
      >
        次へ
      </button>
    </div>
  );
};

export default Pagination;
